import React from 'react';
import { Divider, Stack, Toolbar, Typography } from "@mui/material";
import { useVersionSourceList } from "./useVersionSourceList";
import { ApiResourceTable } from "../../../comps/api-resource-table/ApiResourceTable";
import { LinkButton } from "../../../comps/link-button/LinkButton";
import { AdminAppRoutePaths } from "../../../routes";

const VersionSourceListPage = () => {
  const versionSourceList = useVersionSourceList();

  return (
    <Stack>
      <Toolbar>
        <Typography component="h1" variant="h5">
          Version Sources
        </Typography>
        <Divider orientation="vertical" sx={{ ml: 1, mr: 1 }}/>
        <LinkButton variant="contained" to={AdminAppRoutePaths.versionSourceNew()}>
          <Typography>Add new</Typography>
        </LinkButton>
      </Toolbar>

      <Divider sx={{ mb: 2 }} />

      <ApiResourceTable {...versionSourceList} />
    </Stack>
  );
}

export default VersionSourceListPage;
